
import './DatePicker.css'; // CSS file for styling

import React, { useEffect, useRef, useState } from 'react';

const DatePicker = ({ handleDateSelection }) => {
  const [selectedDay, setSelectedDay] = useState(new Date().getDate());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(1999);

  const dayContainerRef = useRef(null);
  const monthContainerRef = useRef(null);
  const yearContainerRef = useRef(null);

  

  console.log('selectedYear', selectedYear);
  console.log('selectedMonth', selectedMonth);
  console.log('selectedDay', selectedDay);

 

  console.log(selectedDay);
  console.log(selectedMonth);
  console.log(selectedYear);

  
  const getFormattedDate = () => {
    const year = selectedYear.toString();
    const month = selectedMonth.toString().padStart(2, '0');
    const day = selectedDay.toString().padStart(2, '0');
    return `${year}/${month}/${day}`;
  };
  
 
   
      const formattedDate = getFormattedDate();
      console.log('formattedDate', formattedDate); // For debugging
      // onDateSelect(formattedDate);

      // if (typeof onDateSelect === 'function') {
      //   onDateSelect(formattedDate);
      // }

      useEffect(()=>{
        handleDateSelection(formattedDate)
      }, [])
    
  

      const handleScroll = (containerRef, setter) => {
        const container = containerRef.current;
        
        // Prevent function execution if container is null
        if (!container) return;
      
        const items = container.getElementsByClassName('date-picker-item');
        const containerHeight = container.offsetHeight;
        const itemHeight = items[0]?.offsetHeight; // Add safety check in case items are empty
        if (!itemHeight) return; // Prevent further calculations if itemHeight is invalid
      
        const scrollTop = container.scrollTop - container.offsetTop; // Adjust for container's offset
        const middleIndex = Math.floor((scrollTop + containerHeight / 2) / itemHeight); // Calculate the middle index
        const selectedValue = items[middleIndex].dataset.value; // Use dataset.value to retrieve the selected value
        setter(selectedValue);
      
        // Adjust scroll position for first and last items
        const maxScrollTop = container.scrollHeight - containerHeight;
        if (scrollTop === 0) {
          container.scrollTop = 1; // Scroll down by 1 pixel
        } else if (scrollTop >= maxScrollTop) {
          container.scrollTop = maxScrollTop - 1; // Scroll up by 1 pixel
        }
      };
      

  const handleDayScroll = () => {
    handleScroll(dayContainerRef, setSelectedDay);
  };

  const handleMonthScroll = () => {
    handleScroll(monthContainerRef, setSelectedMonth);
  };

  const handleYearScroll = () => {
    handleScroll(yearContainerRef, setSelectedYear);
  };

  const scrollToSelectedDay = () => {
    if (dayContainerRef.current) {
      const container = dayContainerRef.current;
      const items = container.getElementsByClassName('date-picker-item');
      const itemHeight = items[0].offsetHeight;
      const scrollOffset = Math.floor((container.offsetHeight - itemHeight) / 2);
      const selectedIndex = selectedDay - 1; // Adjust index to match selected day
      container.scrollTop = selectedIndex * itemHeight - scrollOffset;
    }
  };

  const scrollToSelectedMonth = () => {
    if (monthContainerRef.current) {
      const container = monthContainerRef.current;
      const items = container.getElementsByClassName('date-picker-item');
      const itemHeight = items[0].offsetHeight;
      const scrollOffset = Math.floor((container.offsetHeight - itemHeight) / 2);
      const selectedIndex = selectedMonth - 1; // Adjust index to match selected month
      container.scrollTop = selectedIndex * itemHeight - scrollOffset;
    }
  };

  const scrollToSelectedYear = () => {
    if (yearContainerRef.current) {
      const container = yearContainerRef.current;
      const items = container.getElementsByClassName('date-picker-item');
      const itemHeight = items[0].offsetHeight;
      const scrollOffset = Math.floor((container.offsetHeight - itemHeight) / 2);
      const selectedIndex = selectedYear - 1000; // Adjust index to match selected year
      container.scrollTop = selectedIndex * itemHeight - scrollOffset;
    }
  };

  useEffect(() => {
    dayContainerRef?.current?.addEventListener('scroll', handleDayScroll);
    monthContainerRef?.current?.addEventListener('scroll', handleMonthScroll);
    yearContainerRef?.current?.addEventListener('scroll', handleYearScroll);
  
    return () => {
      dayContainerRef?.current?.removeEventListener('scroll', handleDayScroll);
      monthContainerRef?.current?.removeEventListener('scroll', handleMonthScroll);
      yearContainerRef?.current?.removeEventListener('scroll', handleYearScroll);
    };
  }, [handleDayScroll, handleMonthScroll, handleYearScroll]);

  useEffect(() => {
    // Update the number of days based on the selected month and year
    const daysInMonth = getDaysInMonth(selectedMonth, selectedYear);
    setSelectedDay((prevSelectedDay) => {
      if (prevSelectedDay > daysInMonth) {
        return null; // Reset selected day if it exceeds the number of days in the month
      }
      return prevSelectedDay;
    });
  }, [selectedMonth, selectedYear]);



  const getDaysInMonth = (month, year) => {
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    const daysInMonth = [
      31, // January
      isLeapYear ? 29 : 28, // February (accounting for leap year)
      31, // March
      30, // April
      31, // May
      30, // June
      31, // July
      31, // August
      30, // September
      31, // October
      30, // November
      31, // December
    ];
    return daysInMonth[month - 1];
  };

  const renderDays = () => {
    const daysInMonth = getDaysInMonth(selectedMonth, selectedYear);
    const days = [];
    for (let i = 1; i <= daysInMonth; i++) {
      const isSelected = selectedDay === i;
      const isMiddle = Math.floor(daysInMonth / 2) + 1 === i;
      const className = `date-picker-item${isSelected ? ' selected' : ''}${isMiddle ? ' middle' : ''}`;
      days.push(
        <div key={i} className={className} data-value={i}>
          {i}
        </div>
      );
    }
    return (
      <div className="date-picker-column" ref={dayContainerRef} onScroll={handleDayScroll}>
        <div className="date-picker-items">
          <div className="date-picker-item-placeholder" />
          {days}
          <div className="date-picker-item-placeholder" />
        </div>
      </div>
    );
  };
  
  const renderMonths = () => {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    const renderedMonths = months.map((month, index) => {
      const isSelected = selectedMonth === index + 1;
      const isMiddle = Math.floor(months.length / 2) + 1 === index + 1;
  
      const className = `date-picker-item${isSelected ? ' selected' : ''}${isMiddle ? ' middle' : ''}`;
  
      return (
        <div key={index + 1} className={className} data-value={index + 1}>
          {month}
        </div>
      );
    });
  
    return (
      <div className="date-picker-column" ref={monthContainerRef} onScroll={handleMonthScroll}>
        <div className="date-picker-items">{renderedMonths}</div>
      </div>
    );
  };
  
  const renderYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 1000; i <= currentYear; i++) {
      const isSelected = selectedYear === i;
      const isMiddle = Math.floor((currentYear - 1000) / 2) + 1000 === i;
  
      const className = `date-picker-item${isSelected ? ' selected' : ''}${isMiddle ? ' middle' : ''}`;
  
      years.push(
        <div key={i} className={className} data-value={i}>
          {i}
        </div>
      );
    }
  
    return (
      <div className="date-picker-column" ref={yearContainerRef} onScroll={handleYearScroll}>
        <div className="date-picker-items">{years}</div>
      </div>
    );
  };
  
    

  useEffect(() => {
    scrollToSelectedDay();
    scrollToSelectedMonth();
    scrollToSelectedYear();
  }, []);

  return (
    <div className="date-picker">
      <div className="date-picker-inner">
        {renderDays()}
        {renderMonths()}
        {renderYears()}
      </div>
    </div>
  );
};

export default DatePicker;
